import { render, staticRenderFns } from "./ShareAssertions.vue?vue&type=template&id=9b03f000"
import script from "./ShareAssertions.vue?vue&type=script&lang=js"
export * from "./ShareAssertions.vue?vue&type=script&lang=js"
import style0 from "./ShareAssertions.vue?vue&type=style&index=0&id=9b03f000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports